import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchHorseShowEntryService } from '../../providers/search-horse-show-entry.service';
import { Horse_show_entry } from '../../models/horse_show_entry';
import { faSearch} from '@fortawesome/fontawesome-pro-regular';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-modal-entry-search',
  templateUrl: './modal-entry-search.component.html',
styleUrls:  ['./modal-entry-search.component.css']
})
export class ModalEntrySearchComponent extends SmsAbstractAppPage implements OnInit {

	@Input() horse_show_id: string;
	@Output() entry_selected$: EventEmitter<Horse_show_entry> = new EventEmitter<Horse_show_entry>();
	faSearch = faSearch;
	entry_list: Horse_show_entry[] = [];

  constructor(public activeModal: NgbActiveModal, private searchHorseShowEntryService: SearchHorseShowEntryService) {
  	super();
  }

  ngOnInit() {
  }

  handleSelectEntry(hs_entry: Horse_show_entry){
  	this.entry_selected$.emit(hs_entry);
  }

  handleSearchEntryByNumber(entry_number: string){
  	this.searchHorseShowEntryService.getByEntryNumber(this.horse_show_id, parseInt(entry_number)).then(entry_list => {
  		this.entry_list = entry_list;
  	}).catch(error => {
  		this.handleError(error);
  	});
  }

  handleGetCompetitor(arg_1: any){}

}
